import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import OptionButton from '@/components/common/OptionButton/OptionButton';
import MinusIcon from '@/components/common/OptionButton/icons/Minus/MinusIcon';
import CancelContractReasonModal from './components/CancelContractReasonModal';
import useCancelContractLines from './hooks/useCancelContractLines';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import { getReasonTypes } from '@/utils/data-helpers/reasonTypes';
import { useGetReasonCodes } from '@/pages/SystemAdmin/ReasonCodes/hooks/useGetReasonCodes';
import { CANCEL_TYPE } from '@/config/reasonTypes.config';
import {
  useSelectedLines
} from '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/linesSelectionObservable';
import { useSelectedVariableLines } from
  '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/variableLinesSelectionObservable';

export default function CancelledStatusContainer() {
  const { contractId }: { contractId: UUID } = useParams();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { cancelContractLines } = useCancelContractLines();
  const reasonTypes = getReasonTypes();
  const selectedLineRows = useSelectedLines();
  const selectedVariableLineRows = useSelectedVariableLines();
  const selectedLines = selectedLineRows.length ? selectedLineRows : selectedVariableLineRows;

  const { contract } = useGetContractDetails(contractId);
  const { reasonCodes, isLoading, getReasonCodes } = useGetReasonCodes();

  useEffect(() => {
    if (isOpenModal) {
      getReasonCodes(CANCEL_TYPE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenModal]);

  if (contract?.status.status === 'Cancelled' || contract?.status.status === 'Expired') {
    return null;
  }

  return (
    <>
      {isOpenModal && (
        <CancelContractReasonModal
          reasonCodes={reasonCodes}
          reasonTypes={reasonTypes}
          cancelContractLines={cancelContractLines}
          onClose={() => setIsOpenModal(false)}
          selectedContractLinesCount={selectedLines.length}
          isLoadingReasonCodes={isLoading}
        />
      )}

      <OptionButton
        Icon={<MinusIcon variant='cancel' />}
        onClick={() => setIsOpenModal(true)}
      >
        Cancel line(s)
      </OptionButton>
    </>
  );
}
